import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageKeys } from '../enums/storage-keys.enum';
import { UrlKeys } from '../enums/urls.enum';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';

export const reimbursementGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  return inject(AuthService).isLogged() && getAuthorized()
    ? true
    : inject(Router).createUrlTree([`/${UrlKeys.HOME}`]);
};

function getAuthorized(): boolean {
  const logData = inject(StorageService).sessionStorageGetItem(StorageKeys.LOGIN_DATA);
  let authorizedDerechoReembolso: boolean = false;
  for (let i = 0; i <= logData.authorized?.length; i++) {
    if (logData.authorized[i]?.showReimbursement) {
      authorizedDerechoReembolso = true;
    }
  }
  return !logData.isPremember && (!!logData.showReimbursement || !!authorizedDerechoReembolso);
}
